var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4.4408921e-16 0 8.23382651 0 8.23382651 10.5777 4.4408921e-16 10.5777"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 8.8817842e-16 13.9999 8.8817842e-16 13.9999 4.94655 0 4.94655"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/download",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.888273, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41282651,10.2817 C3.52082651,10.3887 3.62982651,10.4637 3.74282651,10.5077 C3.85582651,10.5537 3.97982651,10.5777 4.11182651,10.5777 C4.24382651,10.5777 4.36782651,10.5537 4.47782651,10.5097 C4.59282651,10.4637 4.70482651,10.3867 4.81082651,10.2817 L7.93782651,7.1547 C8.13082651,6.9607 8.23382651,6.7157 8.23382651,6.4457 C8.23382651,6.1757 8.13082651,5.9297 7.93782651,5.7357 C7.55082651,5.3497 6.90282651,5.3507 6.51882651,5.7357 L5.10682651,7.1487 L5.10682651,0.9887 C5.10682651,0.7107 5.00682651,0.4647 4.82182651,0.2807 C4.44882651,-0.0923 3.77582651,-0.0953 3.40282651,0.2797 C3.21582651,0.4657 3.11682651,0.7107 3.11682651,0.9887 L3.11682651,7.1417 L1.72582651,5.7357 C1.33782651,5.3497 0.689826506,5.3507 0.306826506,5.7357 C0.114826506,5.9287 0.0118265062,6.1617 0.00082650617,6.4317 C-0.0101734938,6.7067 0.0888265062,6.9567 0.285826506,7.1557 L3.41282651,10.2817 Z",
    id: "Fill-1",
    fill: "#FF7800",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 9.047450)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7139,0.28075 C13.3389,-0.09325 12.6719,-0.09425 12.2949,0.28175 C12.1089,0.46875 12.0099,0.71475 12.0099,0.99075 L12.0099,2.95675 L1.9899,2.95675 L1.9899,0.99075 C1.9899,0.71475 1.8909,0.46875 1.7039,0.28075 C1.3289,-0.09325 0.6619,-0.09425 0.2849,0.28175 C0.0989,0.46875 -0.0001,0.71475 -0.0001,0.99075 L-0.0001,3.33075 C-0.0001,3.76375 0.1619,4.14475 0.4819,4.46475 C0.8029,4.78375 1.1839,4.94675 1.6159,4.94675 L12.3839,4.94675 C12.8159,4.94675 13.1969,4.78375 13.5179,4.46475 C13.8379,4.14475 13.9999,3.76375 13.9999,3.33075 L13.9999,0.99075 C13.9999,0.71475 13.9009,0.46875 13.7139,0.28075",
    id: "Fill-4",
    fill: "#FF7800",
    mask: "url(#mask-4)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.380d98904cce2f5c558ff150504d49d3.svg";
export { ForwardRef as ReactComponent };